// src/components/Footer.js
export default function Footer() {
    return (
      <footer className="bg-[#2f2301] text-white text-sm py-10 px-6">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:justify-between gap-8">
          <div className="text-center md:text-left">
            <h2 className="text-2xl font-bold mb-2">ボドゲ診断</h2>
            <p className="text-xs text-gray-300 mt-6 md:mt-20">© 2025 ボドゲ診断</p>
          </div>
          <div className="flex flex-col text-center md:text-left space-y-2">
            <a href="/games" className="hover:underline">掲載ゲーム一覧</a>
            <a href="/characters" className="hover:underline">キャラクター一覧</a>
            <a href="/terms" className="hover:underline">利用規約</a>
            <a href="/privacy" className="hover:underline">プライバシーポリシー</a>
            <a href="/contact" className="hover:underline">お問い合わせ</a>
          </div>
          <div className="text-center md:text-right">
            <a href="/entry" className="font-bold text-lg hover:underline block">
              ボードゲーム掲載ご希望の方はこちら
            </a>
          </div>
        </div>
      </footer>
    );
  }
  